import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import SelectInput from 'components/select_input';
import CalendarDay from './calendar_day';
import Querier from 'querier';
import HistoryPaginator from './history_paginator';

const Month = (props) => {
  // This fun thing takes the float to a string and trims the first two decimals. Necessary to avoid rounding 99.9999 up to 100.00.
  const uptimePercentage = (props.month.uptime_percentage * 100.00).toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
  return (
    <div className="calendar-month">
      <div className="month-header">
        <h6 className="month-name">
          {props.month.name} <var data-var="year">{props.month.year}</var>
        </h6>
        <small className="month-uptime">{ uptimePercentage }%</small>
      </div>
      <Calendar month={props.month} />
    </div>
  );
};

const Calendar = (props) => {
  const leftPadding = Array(props.month.start_offset).fill().map((_, i) => {
    return (
      <CalendarDay hidden key={ `${i}-padding` } />
    );
  });

  const days = props.month.days.map((day, i) => {
    return <CalendarDay key={i} color={day.color} tooltip={day.tooltip} />;
  });

  return (
    <div className="days">{ leftPadding.concat(days) }</div>
  );
};

class UptimeHistory extends Component {
  /*
   * Top level wrapper for the uptime calendar, takes an array of showcased components,
   * and an object of month data for display.
   *
   * @param {object} props
   * @param {object} components_select_list = array of component name/value for the select input
   * @param {object} months = object representing a month that contains a day count, starts_on day, and the component uptime for that month
   */

  constructor (props) {
    super(props);

    this.state = {
      component_select_list: props.component_select_list,
      component: props.component,
      months: props.months,
    };

    this._changeComponent = this._changeComponent.bind(this);
    this._handlePagination = this._handlePagination.bind(this);
  }

  _drawMonths () {
    return this.state.months.map(month => (
      <Month
        key={month.name}
        month={month}
      />
    ));
  }

  _changeComponent (event) {
    const componentCode = event.target.options[event.target.selectedIndex].value;
    const path = `/uptime/${componentCode}`;
    Querier.fetch({}, { path, merge: true }).then((data) => {
      this.setState({
        component_select_list: data.component_select_list,
        component: data.component,
        months: data.months,
      });
    });
  }

  _handlePagination (data) {
    this.setState({
      component_select_list: data.component_select_list,
      component: data.component,
      months: data.months,
    });
  }

  render () {
    const startDateMonth = this.state.months[0].name;
    const startDateYear = this.state.months[0].year;
    const endDateMonth = this.state.months[2].name;
    const endDateYear = this.state.months[2].year;

    return (
      <div className="uptime-calendar">
        <div className="uptime-header">
          <div className="component-selector">
            <SelectInput
              name="component"
              defaultValue={this.state.component.id}
              options={this.state.component_select_list}
              onChange={this._changeComponent} />
          </div>
          <HistoryPaginator startDateMonth={startDateMonth} startDateYear={startDateYear} endDateMonth={endDateMonth} endDateYear={endDateYear} responseHandler={this._handlePagination} />
        </div>
        <div className="uptime-calendar-display">
          { this._drawMonths() }
        </div>
      </div>
    );
  }
}

Month.propTypes = {
  month: PropTypes.object.isRequired,
};

Calendar.propTypes = {
  month: PropTypes.object.isRequired,
};

UptimeHistory.propTypes = {
  component_select_list: PropTypes.arrayOf(PropTypes.object).isRequired,
  component: PropTypes.object.isRequired,
  months: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default UptimeHistory;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/status/uptime_calendar.jsx